import { option, pipe } from '@code-expert/prelude';
/**
 * Guard a render tree from rendering unless we have a value
 */
export const GuardOption = ({ value, render, alt = () => null, }) => pipe(value, option.fold(alt, render));
//# sourceMappingURL=GuardOption.js.map